import { StyledGridContainer } from '@components/Grid/Grid.style';
import { StyledParagraph } from '@components/Text';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { LabelColor, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DivAllCenter } from '@pages/CommonStyle/commonDiv.style';
import { BeaconPage, CardTextBox, DescBox, Layout, NormalCard } from './Product.style';
import { useLocation } from 'react-router-dom';
import { HeadingH3, HeadingH3white } from '@components/Text/Heading/Heading.style';

import home from '@src/lang/ko/main/home/home';
import homeEn from '@src/lang/en/main/home/home';
import homeJp from '@src/lang/jp/main/home/home';
import homeCn from '@src/lang/cn/main/home/home';
import { BannerBtnAtag } from '../Banner/Banner.style';
import i18n from '@pages/i18n';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import simple from '@src/lang/ko/simple';

const Products = () => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  const [layoutMaxWidth, setLayoutMaxWidth] = useState<any>(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setLayoutMaxWidth(window.innerWidth);
    };

    setLayoutMaxWidth(document.documentElement.clientWidth);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <StyledGridContainer>
        <BeaconPage>
          {/* RTLS 제품 */}
          <DivAllCenter>
            <DisplayH2 size="small">
              <Trans i18nKey={`home.products.title`} />
            </DisplayH2>
            <Spacing pixel="16" />
            <StyledParagraph size="medium">
              <p>
                <Trans i18nKey={`home.products.desc`} />
              </p>
            </StyledParagraph>
            <Spacing pixel="48" />
          </DivAllCenter>

          <Layout>
            {home.products.card.map((data, i) => (
              <>
                <NormalCard
                  w={layoutMaxWidth}
                  img={data.img[layoutType]}
                  // href={getPath(i)}
                  // target="_blank"
                  rel="noopener noreferrer"
                >
                  <CardTextBox>
                    <HeadingH3 size="small">
                      <Trans i18nKey={`home.products.card.${i}.title`} />
                    </HeadingH3>
                    <Spacing pixel="4" />
                    <ParagraphColor color={'#646464'} size={'small'}>
                      <Trans i18nKey={`home.products.card.${i}.desc`} />
                    </ParagraphColor>
                    <Spacing pixel="16" />

                    <ShowMoreButton href={i18n.language === 'ko' ? `${home.products.card[i].link}` : `/${i18n.language}${data.link}`} rel="noopener noreferrer">
                      <img src={simple.showmoreImg[i18n.language]} alt="learn more button" />
                    </ShowMoreButton>
                  </CardTextBox>
                </NormalCard>
              </>
            ))}
          </Layout>

          <SpacingDTM d="128" t="128" m="96" />

          {/* 영상 제품 */}
          <DivAllCenter>
            <DisplayH2 size="small">
              <Trans i18nKey={`home.camera.title`} />
            </DisplayH2>
            <Spacing pixel="16" />
            <StyledParagraph size="medium">
              <p>
                <Trans i18nKey={`home.camera.desc`} />
              </p>
            </StyledParagraph>
            <Spacing pixel="48" />
          </DivAllCenter>

          <Layout>
            {home.camera.card.map((data, i) => (
              <>
                <NormalCard
                  w={layoutMaxWidth}
                  img={data.img[layoutType]}
                  // href={getPath(i)}
                  // target="_blank"
                  rel="noopener noreferrer"
                >
                  <CardTextBox>
                    <HeadingH3 size="small">
                      <Trans i18nKey={`home.camera.card.${i}.title`} />
                    </HeadingH3>
                    <Spacing pixel="4" />
                    <ParagraphColor color={'#646464'} size={'small'}>
                      <p>
                        <Trans i18nKey={`home.camera.card.${i}.desc`} />
                      </p>
                    </ParagraphColor>
                    <Spacing pixel="16" />

                    <ShowMoreButton
                      href={i18n.language === 'ko' ? `${home.camera.card[i].link}` : `/${i18n.language}${home.camera.card[i].link}`}
                      rel="noopener noreferrer"
                    >
                      <img src={simple.showmoreImg[i18n.language]} alt="learn more button" />
                    </ShowMoreButton>
                  </CardTextBox>
                </NormalCard>
              </>
            ))}
          </Layout>
        </BeaconPage>
      </StyledGridContainer>
    </>
  );
};

export default Products;
